import React from "react";

import { getPreviewFramePrintFontSize } from "@/utils/qrEditorHelper";

import { QRFRameToPrintProps } from "../types";

import { uriText } from "./uri";

import "../styles.scss";

export const ReviewFrameToDownload = (
  props: QRFRameToPrintProps
): React.SVGProps<SVGSVGElement> => {
  const {
    text,
    textColor,
    frameColor,
    frameBackgroundColor,
    height = 1200,
    qrSvg,
    width = 900,
  } = props;

  const fontSize = getPreviewFramePrintFontSize(text?.length);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none">
      <style>
        {`
              @font-face {
                font-family: 'Nunito Sans';
                src: url(${uriText});
                font-weight: bold
              }
            `}
      </style>
      <g id="surface1">
        <path
          fillRule="nonzero"
          fill="white"
          fillOpacity="1"
          strokeWidth="1"
          stroke="#BFBFBF"
          d="M 7.999875 0.5 L 88.000125 0.5 C 92.142 0.5 95.500125 3.857839 95.500125 8 L 95.500125 120 C 95.500125 124.142161 92.142 127.5 88.000125 127.5 L 7.999875 127.5 C 3.858 127.5 0.499875 124.142161 0.499875 120 L 0.499875 8 C 0.499875 3.857839 3.858 0.5 7.999875 0.5 Z M 7.999875 0.5 "
          transform="matrix(10.416667,0,0,10.414062,0,0)"
        />

        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 488.316406 104.238281 C 538.488281 102.453125 570.957031 125.183594 585.730469 172.421875 C 588.632812 186.023438 588.386719 199.566406 584.996094 213.042969 C 612.835938 212.800781 640.664062 213.042969 668.492188 213.769531 C 673.621094 214.976562 676.792969 218.121094 678.015625 223.199219 C 678.992188 284.128906 678.992188 345.0625 678.015625 405.992188 C 676.863281 410.464844 674.179688 413.605469 669.957031 415.421875 C 627.476562 415.90625 584.996094 416.390625 542.515625 416.871094 C 531.980469 430.46875 520.75 443.527344 508.824219 456.042969 C 502.964844 458.945312 497.105469 458.945312 491.246094 456.042969 C 480.015625 442.984375 468.789062 429.929688 457.554688 416.871094 C 415.074219 416.390625 372.59375 415.90625 330.113281 415.421875 C 327.5 414.28125 325.300781 412.589844 323.523438 410.34375 C 321.105469 348.046875 320.617188 285.667969 322.058594 223.199219 C 323.277344 218.121094 326.453125 214.976562 331.578125 213.769531 C 359.40625 213.042969 387.238281 212.800781 415.074219 213.042969 C 406.964844 155.085938 431.378906 118.816406 488.316406 104.238281 Z M 486.851562 114.394531 C 535.398438 111.488281 565.425781 133.25 576.941406 179.675781 C 580.113281 221.042969 562.289062 249.332031 523.472656 264.546875 C 479.402344 274.03125 447.421875 258.800781 427.527344 218.847656 C 415.308594 179.976562 425.808594 148.789062 459.019531 125.273438 C 467.960938 120.316406 477.238281 116.691406 486.851562 114.394531 Z M 396.03125 297.1875 C 399.757812 296.613281 402.933594 297.578125 405.554688 300.089844 C 408.238281 305.40625 410.925781 310.726562 413.609375 316.046875 C 419.363281 317.722656 425.222656 318.929688 431.1875 319.671875 C 436.941406 320.515625 439.136719 323.660156 437.78125 329.101562 C 433.386719 333.457031 428.992188 337.808594 424.597656 342.160156 C 423.960938 349.28125 424.695312 356.292969 426.792969 363.195312 C 425.730469 369.121094 422.316406 371.054688 416.539062 369 C 411.117188 366.3125 405.746094 363.652344 400.425781 361.019531 C 393.589844 363.921875 386.753906 366.820312 379.917969 369.722656 C 377.679688 369.679688 375.96875 368.714844 374.792969 366.820312 C 375.121094 358.582031 375.609375 350.363281 376.257812 342.160156 C 354.359375 325.75 357.53125 317.285156 385.777344 316.773438 C 389.402344 310.316406 392.820312 303.789062 396.03125 297.1875 Z M 497.105469 297.1875 C 501.246094 296.578125 504.417969 298.03125 506.628906 301.539062 C 509.226562 306.203125 511.425781 311.039062 513.21875 316.046875 C 519.441406 317.859375 525.789062 319.066406 532.261719 319.671875 C 537.207031 321.164062 538.917969 324.308594 537.390625 329.101562 C 532.996094 333.457031 528.601562 337.808594 524.207031 342.160156 C 523.886719 349.230469 524.621094 356.242188 526.402344 363.195312 C 525.4375 369.117188 522.019531 371.050781 516.148438 369 C 511.179688 365.570312 505.808594 362.910156 500.035156 361.019531 C 494.265625 362.910156 488.894531 365.570312 483.921875 369 C 480.226562 370.296875 477.050781 369.570312 474.402344 366.820312 C 475.050781 358.621094 475.539062 350.398438 475.867188 342.160156 C 471.472656 337.808594 467.078125 333.457031 462.683594 329.101562 C 461.15625 324.308594 462.867188 321.164062 467.808594 319.671875 C 474.285156 319.066406 480.632812 317.859375 486.851562 316.046875 C 489.9375 309.445312 493.355469 303.15625 497.105469 297.1875 Z M 596.714844 297.1875 C 599.597656 296.839844 602.285156 297.324219 604.773438 298.636719 C 607.757812 304.796875 610.933594 310.839844 614.292969 316.773438 C 621.6875 317.953125 629.011719 319.40625 636.265625 321.125 C 637.429688 322.699219 638.40625 324.390625 639.195312 326.203125 C 635.324219 332.695312 630.199219 338.015625 623.816406 342.160156 C 623.734375 348.957031 624.46875 355.730469 626.011719 362.46875 C 625.773438 368.273438 622.84375 370.449219 617.222656 369 C 611.53125 365.9375 605.671875 363.277344 599.644531 361.019531 C 593.347656 364.5 586.753906 367.402344 579.871094 369.722656 C 576.664062 369.9375 574.710938 368.484375 574.011719 365.371094 C 575.128906 357.722656 575.617188 349.988281 575.476562 342.160156 C 571.082031 337.808594 566.6875 333.457031 562.292969 329.101562 C 560.9375 323.660156 563.132812 320.515625 568.882812 319.671875 C 574.914062 319.203125 580.773438 317.992188 586.460938 316.046875 C 589.523438 309.488281 592.945312 303.203125 596.714844 297.1875 Z M 596.714844 297.1875 "
        />
        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 467.515625 155.800781 C 482.457031 154.914062 488.070312 161.683594 484.359375 176.109375 C 476.058594 185.78125 467.757812 185.78125 459.457031 176.109375 C 456.566406 166.9375 459.25 160.167969 467.515625 155.800781 Z M 467.515625 155.800781 "
        />
        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 531.96875 155.800781 C 546.230469 155.511719 551.847656 162.28125 548.8125 176.109375 C 540.511719 185.78125 532.210938 185.78125 523.910156 176.109375 C 521.007812 166.800781 523.691406 160.03125 531.96875 155.800781 Z M 531.96875 155.800781 "
        />
        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 480.699219 202.222656 C 482.710938 201.996094 484.664062 202.238281 486.558594 202.949219 C 488.335938 209.871094 492.238281 215.191406 498.277344 218.90625 C 510.902344 221.414062 518.46875 216.335938 520.980469 203.675781 C 523.425781 201.738281 525.863281 201.738281 528.304688 203.675781 C 529.238281 217.050781 523.132812 225.511719 509.996094 229.0625 C 495.527344 231.207031 485.515625 225.648438 479.964844 212.378906 C 478.9375 208.855469 479.179688 205.46875 480.699219 202.222656 Z M 480.699219 202.222656 "
        />

        <path
          stroke="none"
          fillRule="nonzero"
          fill={frameBackgroundColor}
          d="M 260.417969 479.046875 L 739.582031 479.046875 C 751.089844 479.046875 760.417969 488.371094 760.417969 499.875 L 760.417969 978.921875 C 760.417969 990.425781 751.089844 999.75 739.582031 999.75 L 260.417969 999.75 C 248.910156 999.75 239.582031 990.425781 239.582031 978.921875 L 239.582031 499.875 C 239.582031 488.371094 248.910156 479.046875 260.417969 479.046875 Z M 260.417969 479.046875 "
        />
        <g
          stroke="null"
          transform="matrix(6.2212 0 0 6.2212 0 -55)"
          id="svg_485">
          <g
            dangerouslySetInnerHTML={{ __html: qrSvg }}
            stroke="null"
            id="svg_486"></g>
        </g>
        <text
          x="500"
          y="1100.3999700784689"
          dominantBaseline="middle"
          textAnchor="middle"
          fill={textColor}
          fontFamily="Nunito Sans"
          style={{ fontSize }}>
          {text}
        </text>
      </g>
    </svg>
  );
};
